/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForActivityLogAws extends models.GovernanceConfigurationBaseForActivityLog {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForActivityLogAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForActivityLogAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForActivityLogAws>): GovernanceConfigurationForActivityLogAws {
        let obj = Object.assign(new GovernanceConfigurationForActivityLogAws(), model);
        GovernanceConfigurationForActivityLogAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForActivityLogAws>): GovernanceConfigurationForActivityLogAws {
        if (!model) return null;
        return GovernanceConfigurationForActivityLogAws.newInstance(<GovernanceConfigurationForActivityLogAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForActivityLogAws) {
        if (!obj) return;

        models.GovernanceConfigurationForActivityLogAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForActivityLogAws): boolean {
        if (models.GovernanceConfigurationBaseForActivityLog.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForActivityLogAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region Id
     */
    region: string;

    /**
     * Name of the trail
     */
    trail_name: string;

    /**
     * S3 bucket designated for publishing log files
     */
    bucket_name: string;

    /**
     * Specifies whether the trail is created in the current Region or in all Regions
     */
    is_multi_region_trail: boolean;

}
